import { Icon } from '../Icon';
import type { SessionUser } from '../../types';

interface AppHeaderProps {
    sessionUser: SessionUser;
    evalYear: number;
    evalYearOptions: number[];
    changeEvalYear: (year: string | number) => void;
    openPwModal: () => void;
    handleLogout: () => void;
}

export function AppHeader({ sessionUser, evalYear, evalYearOptions, changeEvalYear, openPwModal, handleLogout }: AppHeaderProps) {
    return (
        <header className="bg-slate-900 text-white shadow-md">
            <div className="max-w-7xl mx-auto px-4 py-4 flex flex-col md:flex-row justify-between items-center gap-4">
                <div className="flex items-center gap-3">
                    <div className="bg-indigo-600 p-2 rounded-lg text-white">
                        <Icon name="award" className="w-6 h-6" />
                    </div>
                    <div>
                        <h1 className="text-xl font-bold tracking-tight">개인 성과/역량 관리 플랫폼</h1>
                        <p className="text-xs text-slate-400">3단계 절대평가 및 상시 성과 피드백 혁신 플랫폼</p>
                    </div>
                </div>

                <div className="flex items-center gap-3">
                    <label className="flex items-center gap-2 bg-slate-800 border border-slate-700 px-3 py-2 rounded-xl text-xs">
                        <span className="text-slate-400 font-semibold whitespace-nowrap">평가연도</span>
                        <select
                            value={evalYear}
                            onChange={(e) => changeEvalYear(e.target.value)}
                            className="bg-slate-900 border border-slate-600 text-slate-100 font-bold rounded-lg px-2 py-1 focus:outline-none focus:ring-2 focus:ring-indigo-500 cursor-pointer"
                        >
                            {evalYearOptions.map(y => (
                                <option key={y} value={y}>{y}년</option>
                            ))}
                        </select>
                    </label>
                    <div className="bg-slate-800 border border-slate-700 px-4 py-2 rounded-xl flex items-center gap-3">
                        <div className="bg-indigo-900 text-indigo-300 w-8 h-8 rounded-full flex items-center justify-center font-bold text-xs uppercase">
                            {sessionUser.name.charAt(0)}
                        </div>
                        <div>
                            <span className="font-bold text-xs text-slate-100">{sessionUser.name} {sessionUser.duty}</span>
                            <span className="text-[10px] text-indigo-400 block mt-0.5">{sessionUser.department} | {
                                sessionUser.role === 'EMPLOYEE' ? '팀원 권한' :
                                sessionUser.role === 'EVALUATOR' ? '평가자 권한' : '인사담당자 권한'
                            }</span>
                        </div>
                    </div>
                    <button
                        onClick={openPwModal}
                        className="p-2.5 bg-slate-800 hover:bg-indigo-950 border border-slate-700 hover:border-indigo-800 text-slate-300 hover:text-indigo-300 rounded-xl transition-all"
                        title="비밀번호 변경"
                    >
                        <Icon name="key" className="w-5 h-5" />
                    </button>
                    <button
                        onClick={handleLogout}
                        className="p-2.5 bg-slate-800 hover:bg-rose-950 border border-slate-700 hover:border-rose-900 text-slate-300 hover:text-rose-400 rounded-xl transition-all"
                        title="포털 로그아웃"
                    >
                        <Icon name="log-out" className="w-5 h-5" />
                    </button>
                </div>
            </div>
        </header>
    );
}
